module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/postcss-loader/lib??embedded!./node_modules/less-loader/dist/cjs.js??ref--9-3!./src/app/styles/colors.less
// module id = ./node_modules/raw-loader/index.js!./node_modules/postcss-loader/lib/index.js??embedded!./node_modules/less-loader/dist/cjs.js??ref--9-3!./src/app/styles/colors.less
// module chunks = styles